import { type MouseEventHandler } from 'react';
import cn from 'classnames';
import CloseIcon from 'assets/icons/close-x.svg';
import HamburgerIcon from 'assets/icons/hamburger.svg';
import styles from './hamburger-menu-button.module.scss';

function HamburgerMenuButton({
	isMenuOpen = false,
	handleClick,
}: {
	isMenuOpen?: boolean;
	handleClick: MouseEventHandler<HTMLButtonElement>;
}) {
	return (
		<button type="button" title="Toggle Menu" onClick={handleClick}>
			{isMenuOpen ? (
				<CloseIcon
					className={cn(styles.icon, styles.navIcon)}
					data-testid="hamburger-menu-close-icon"
					aria-hidden="true"
				/>
			) : (
				<HamburgerIcon
					className={cn(styles.icon, styles.navIcon)}
					data-testid="hamburger-menu-open-icon"
					aria-hidden="true"
				/>
			)}
		</button>
	);
}

export { HamburgerMenuButton };
